/**
 * The UV orientation probe of the effects comparer (W3-04; DESIGN.md §12.2 "effect uv origin", P§7): a custom
 * shader that mixes the picture towards red as uv.x grows and towards green as uv.y grows (`amount` of the way, so
 * at uv (0, 0) towards black). The preview assumes uv (0, 0) is the bottom-left corner (R§9); in a Phira capture of
 * the kit, Phira agrees exactly when the top-left corner turns green, the bottom-right red, and the bottom-left gets
 * no red or green tint (it only gets darker). It runs through the custom-shader path (`#version` line, its own
 * precision, a `%default%` comment), so it also checks that path against Phira.
 */

import type { BuiltinUniform } from '../builtin/index';
import { m } from './effectsDev.messages';

export const UV_PROBE_SOURCE = `#version 100
precision mediump float;

varying lowp vec2 uv;
uniform sampler2D screenTexture;
uniform float amount; // %0.6% 0..1

// Phiedit UV orientation probe: red grows with uv.x, green with uv.y.
// With uv (0, 0) at the bottom-left, the top-left turns green, the bottom-right red,
// and the bottom-left gets no red or green tint (it only gets darker).
void main() {
  vec3 c = texture2D(screenTexture, uv).rgb;
  gl_FragColor = vec4(mix(c, vec3(uv.x, uv.y, 0.0), amount), 1.0);
}
`;

/** The probe's uniforms, described like a built-in's (editor controls). */
export const UV_PROBE_UNIFORMS: readonly BuiltinUniform[] = [
  { name: 'amount', type: 'float', default: 0.6, hint: '0..1', min: 0, max: 1, label: { key: m.probeAmount } },
];
